import { CustomButton } from 'holistic-resources';
import { useEffect, useState } from 'react';
import { FaUserCircle } from 'react-icons/fa';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { ReactComponent as DefaultLogoIcon } from 'images/icons/inspiretec_white_logo.svg';
import { toggleAppOverlay } from 'reducers/ui/uiSlice';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';
import NavMenu from './NavMenu';
import SettingsMenu from './SettingsMenu';
import SmallScreenNavBar from './SmallScreenNavBar';

export default function NavBar({ homeLink }) {
  const {
    whiteLabelSettings: { overviewLogo = '', overviewLogoLarge = false },
  } = useWhiteLabelSettings();
  const [showSmallScreenNavBar, toggleSmallScreenNavBar] = useState(false);
  const [showSettingsMenu, toggleSettingsMenu] = useState(false);
  const dispatch = useDispatch();
  const selectedBooking = useSelector((state) => state.ui.selectedBooking);
  const { componentConfig } = useSelector(
    (state) => state.ui,
  );

  const getLogoLink = () => {
    if (homeLink) return homeLink;
    if (componentConfig?.multiBookingEnabled) return ROUTES_SELF_SERVICE.OVERVIEW;
    if (selectedBooking && (selectedBooking.id || selectedBooking.reference)) {
      return `${ROUTES_SELF_SERVICE.BOOKINGS}/${selectedBooking.id || selectedBooking.reference}`;
    }
    return ROUTES_SELF_SERVICE.OVERVIEW;
  };

  const logoLink = getLogoLink();

  useEffect(() => {
    dispatch(toggleAppOverlay(showSmallScreenNavBar));
  }, [showSmallScreenNavBar, dispatch]);

  return (
    <div className="flex w-full justify-between items-center border-b border-white/[.3] relative navigation-container">
      <NavMenu />
      <div className="z-[1] pt-2 pl-2 pb-2 lg:absolute lg:flex lg:w-full lg:justify-center">
        <Link to={logoLink}>
          {overviewLogo ? (
            <img src={overviewLogo} className={overviewLogoLarge ? "max-h-[6.5rem]" : "max-h-10"} alt="logo" />
          ) : (
            <DefaultLogoIcon className="h-10" />
          )}
        </Link>
      </div>
      <CustomButton
        className="px-3 py-2 text-white text-xl lg:hidden"
        onClick={() => toggleSmallScreenNavBar(true)}
      >
        <FaUserCircle />
      </CustomButton>
      {showSmallScreenNavBar && (
        <SmallScreenNavBar 
          toggleSmallScreenNavBar={toggleSmallScreenNavBar}
        />
      )}
      <div className="relative hidden lg:block z-[3]">
        <CustomButton
          className="hidden lg:block mr-4 py-2 text-white text-xl profile-icon text-[22px]"
          onClick={() => toggleSettingsMenu((currentState) => !currentState)}
        >
          <FaUserCircle />
        </CustomButton>
        {showSettingsMenu && <SettingsMenu />}
      </div>
    </div>
  );
}
